module.exports = __webpack_public_path__ + "static/media/coming_soon.53590598.png";